/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable max-lines */
/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import React, { useState, useRef, useEffect } from 'react'
import { QuestionIconMiniWmo } from '@usap/uicomponents'
import { SkeletonLoader } from '@usap/widgets'
import {
  StyledContainer,
  StyledMain,
  StyledLabelContainer,
  StyledOptionsContainer,
  StyledLoader,
} from './ProductProtection.css'
import Options from './Plans/Options'
import WhatsCoveredDrawer from './WhatsCoveredDrawer'
import trackCartProductProtectionWhatIsCovered from '../../../../../ProductProtectionPlan/gtm/trackCartProductProtectionWhatIsCovered'
import trackCartProductProtectionWhatIsCoveredClose from '../../../../../ProductProtectionPlan/gtm/trackCartProductProtectionWhatIsCoveredClose'
import trackProductProtectionWhatIsCoveredMoreDetialsLink from '../../../../../ProductProtectionPlan/gtm/trackProductProtectionWhatIsCoveredMoreDetailsLink'
import trackCartProductProtectionImpression from '../../../../../ProductProtectionPlan/gtm/trackCartProductProtectionImpression'

const { pageType } = __BROWSER__ && window

const ProductProtection = ({
  data,
}) => {
  const [showOptionsLoader, setShowOptionLoader] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const handleDrawerClose = () => {
    trackCartProductProtectionWhatIsCoveredClose({
      product: {
        part: {
          name: data?.product?.part?.name,
        },
        sku: data?.product?.sku,
      },
    })
    setIsDrawerOpen(false)
  }

  const handleDrawerOpen = () => {
    trackCartProductProtectionWhatIsCovered({
      product: {
        part: {
          name: data?.product?.part?.name,
        },
        sku: data?.product?.sku,
      },
    })
    setIsDrawerOpen(true)
  }

  const selectedPlanId = data?.modifiers?.productProtection?.planId
  const findUrlByProductProtectionPlanId = planId => {
    if (!planId) {
      const defaultPlan = data?.productWarranty?.productProtectionPlan[0]
      return defaultPlan.url
    }

    const protectionPlan = data?.productWarranty?.productProtectionPlan.find(
      plan => plan.code === planId,
    )
    return protectionPlan?.url
  }
  const detailsAndFaqUrl = findUrlByProductProtectionPlanId(selectedPlanId)

  const handleDetailsAndFaqVisit = () => {
    trackProductProtectionWhatIsCoveredMoreDetialsLink(
      {
        product: {
          part: {
            name: data?.product?.part?.name,
          },
          sku: data?.product?.sku,
        },
        url: detailsAndFaqUrl,
      },
      pageType,
    )
    window.open(detailsAndFaqUrl, '_blank', 'noopener noreferrer')
  }

  let shouldShowWhatIsCoveredDrawer = true
  if (
    !data?.productWarranty?.marketing?.learnMoreModal?.whyExtendHeading ||
    !data?.productWarranty?.marketing?.offerTypeModalV2?.headline
  ) {
    shouldShowWhatIsCoveredDrawer = false
  }

  const isTrackEppImpressionImpressionFired = useRef(false)
  useEffect(() => {
    if (!isTrackEppImpressionImpressionFired.current) {
      trackCartProductProtectionImpression({
        sku: data?.product?.sku,
        part_names: data?.product?.part?.name,
      })
      isTrackEppImpressionImpressionFired.current = true
    }
  }, [data?.product?.part?.name, data?.product?.sku])

  return (
    <StyledContainer data-testid="product-protection-plan">
      {showOptionsLoader && (
        <StyledLoader>
          <SkeletonLoader height="100%" width="100%" backgroundColor="#DBDBDB" />
        </StyledLoader>
      )}
      <StyledMain>
        <StyledLabelContainer>
          <span>Add Product Protection Powered by</span>
          <span className="ppp-label-logo">
            <img
              alt="Extend"
              height="16"
              width="52.44"
              src="https://cld.partsimg.com/image/upload/d_noimage.jpg/c_limit,w_53/dpr_3.0/f_auto/q_100/q_auto:best/v1/carparts/shipping-protection/extend-logo-epp"
            />
            {shouldShowWhatIsCoveredDrawer === true && (
              <button type="button" className="ppp-learn-more-button__mobile" onClick={handleDrawerOpen}>
                <QuestionIconMiniWmo width="13" height="13" />
              </button>
            )}
          </span>
          {shouldShowWhatIsCoveredDrawer === true && (
            <span>
              <button type="button" className="ppp-learn-more-button__desktop" onClick={handleDrawerOpen}>
                What&lsquo;s Covered?
              </button>
              <WhatsCoveredDrawer
                drawerApiData={data?.productWarranty}
                isOpen={isDrawerOpen}
                handleDrawerClose={handleDrawerClose}
                handleDetailsAndFaqVisit={handleDetailsAndFaqVisit}
              />
            </span>
          )}
        </StyledLabelContainer>
        <StyledOptionsContainer>
          <Options
            plans={data?.productWarranty?.productProtectionPlan}
            product={data?.product}
            selectedPlan={data?.modifiers?.productProtection}
            setShowOptionLoader={setShowOptionLoader}
            quantity={data?.modifiers?.quantity}
          />
        </StyledOptionsContainer>
      </StyledMain>
    </StyledContainer>
  )
}

export default ProductProtection
